import React, { useState, useRef, useEffect } from "react";
import { QRCode } from "react-qrcode-logo";
import html2canvas from "html2canvas";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import Snackbar from "../../../common/snackbar/components/snackbar";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Card,
  CardContent,
  CardHeader,
  Button,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
} from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  RadioGroup,
  Radio,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import Footer from "../../Home/components/footer";
import Nav_bar from "../../Home/Container/navCon";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
const CustomQRCode = (props) => {
  const [openLogin, setOpenLogin] = useState(true);
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [link, setLink] = useState("");
  const [qrValue, setQrValue] = useState("");
  const [qrSize, setQrSize] = useState(300);
  const [fgColor, setFgColor] = useState("#000000");
  const [bgColor, setBgColor] = useState("#FFFFFF");
  const [eyeColor, setEyeColor] = useState([
    { outer: "#000000", inner: "#000000" },
    { outer: "#000000", inner: "#000000" },
    { outer: "#000000", inner: "#000000" },
  ]);
  const [eyeRadius, setEyeRadius] = useState([
    { outer: 10, inner: 5 },
    { outer: 10, inner: 5 },
    { outer: 10, inner: 5 },
  ]);
  const [qrStyle, setQrStyle] = useState("squares");
  const [logoUrl, setLogoUrl] = useState("");
  const [logoWidth, setLogoWidth] = useState(50);
  const [logoHeight, setLogoHeight] = useState(50);
  const [clearLogoBg, setClearLogoBg] = useState(false);
  const [uniqueId] = useState(uuidv4());
  const [format, setFormat] = useState("");
  const [quality, setQuality] = useState("");
  const [qrType, setQrType] = useState("");
  const [redirectlink, setRedirectlink] = useState("");
  const qrCodeRef = useRef(null);
  const { qrCodeId } = useParams();
  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = () => setLogoUrl(reader.result);
    reader.readAsDataURL(file);
  };

  const handlePrint = async () => {
    if (!qrCodeRef.current) return;

    setTimeout(async () => {
      const canvas = await html2canvas(qrCodeRef.current);
      const imageUrl = canvas.toDataURL();

      // Create a payload with the QR code data and user information
      const payload = {
        addedBy: props.login.user_id,
        qr_id: qrCodeId,
        name,
        email,
        qrType,

        qrSize,
        fgColor,
        bgColor,
        eyeColor,
        eyeRadius,
        qrStyle,
        logoUrl,
        logoWidth,
        logoHeight,
        clearLogoBg,
        format,
        quality,
        redirectlink,
      };

      try {
        // Send the QR code data to the backend
        const response = await axios.post(
          "https://qrcodebackend-458148834331.asia-south1.run.app/qrcode/update",
          // "http://localhost:7002/qrcode/update",
          payload,
          {
            headers: {
              token: `${props.login.token}`, // Include token if needed
            },
          }
        );
        const responseData = response.data.data.qrCode;
        navigate("/qrcode");
      } catch (error) {
        console.error("Error saving QR code data to the backend:", error);
        alert("Failed to save QR code data to the backend.");
      }
    }, 100);
  };

  useEffect(() => {
    const fetchQRCodeData = async () => {
      const token = props.login.token;
      try {
        const payload = { qrCodeId };
        const response = await fetch(
          "https://qrcodebackend-458148834331.asia-south1.run.app/qrcode/viewQrById",
          // "http://localhost:7002/qrcode/viewQrById",
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              token,
            },
            body: JSON.stringify(payload),
          }
        );
        // console.log(response.status);

        if (response.status !== 200) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        // console.log(result);

        const data = result.data.result;

        if (data) {
          // console.log(data, 'Fetch data');
          setName(data.name);
          setEmail(data.email);
          setLink(data.link);
          setRedirectlink(data.redirectUrl);
          setQrSize(data.qrSize);
          setQrType(data.qrType);
          setFgColor(data.fgColor);
          setBgColor(data.bgColor);
          setEyeColor(data.eyeColor);
          setEyeRadius(data.eyeRadius);
          setQrStyle(data.qrStyle);
          setLogoUrl(data.logoUrl);
          setLogoWidth(data.logoWidth);
          setLogoHeight(data.logoHeight);
          setClearLogoBg(data.clearLogoBg);
        } else {
          console.log("Error: No data received from the server");
        }
      } catch (error) {
        console.error("Fetch API error:", error);
      }
    };

    fetchQRCodeData();
  }, [qrCodeId, props.login.token]);

  return (
    <Box>
      <Nav_bar />

      <Box
        sx={{
          minHeight: "60vh",
          padding: "20px",
          backgroundImage:
            "url(https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcREqHQAhLVZ47Xyenj89hwLtgCHK_lGaEODMcAM741unQeyHEPD8rDUycMpi2hVyl4OkKE&usqp=CAU)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}>
        {/* <Snackbar
          open={this.props.snackbar?.response_received}
          close_snack_bar={this.props.close_snack_bar}
          message={this.props.snackbar?.message}
        /> */}
        <Link style={{ direction: "none" }} to="/qrcode">
          {" "}
          <Button variant="contained" color="secondary">
            <ArrowBackIcon /> Back
          </Button>
        </Link>
        <Grid
          container
          spacing={3}
          sx={{ maxWidth: 1200, margin: "auto", p: 2 }}>
          <Grid item xs={12} md={6}>
            <Card
              sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
              <CardHeader title="Custom QR Code Generator - Form" />
              <CardContent sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Full Name"
                      variant="outlined"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Email ID"
                      variant="outlined"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      fullWidth
                    />
                  </Grid>
                  {qrType !== "Static" && (
                    <Grid item xs={12}>
                      <TextField
                        label="Link"
                        variant="outlined"
                        value={redirectlink}
                        onChange={(e) => setRedirectlink(e.target.value)}
                        // InputProps={{
                        //   readOnly: true,
                        // }}
                        fullWidth
                      />
                    </Grid>
                  )}

                  <Grid item xs={12}>
                    <TextField
                      label="QR Code Size"
                      variant="outlined"
                      type="number"
                      value={qrSize}
                      onChange={(e) => setQrSize(Number(e.target.value))}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Foreground Color"
                      variant="outlined"
                      type="color"
                      value={fgColor}
                      onChange={(e) => setFgColor(e.target.value)}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Background Color"
                      variant="outlined"
                      type="color"
                      value={bgColor}
                      onChange={(e) => setBgColor(e.target.value)}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Eye Outer Color"
                      variant="outlined"
                      type="color"
                      value={eyeColor[0].outer}
                      onChange={(e) =>
                        setEyeColor([
                          { ...eyeColor[0], outer: e.target.value },
                          { ...eyeColor[1], outer: e.target.value },
                          { ...eyeColor[2], outer: e.target.value },
                        ])
                      }
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Eye Inner Color"
                      variant="outlined"
                      type="color"
                      value={eyeColor[0].inner}
                      onChange={(e) =>
                        setEyeColor([
                          { ...eyeColor[0], inner: e.target.value },
                          { ...eyeColor[1], inner: e.target.value },
                          { ...eyeColor[2], inner: e.target.value },
                        ])
                      }
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Eye Outer Radius"
                      variant="outlined"
                      type="number"
                      value={eyeRadius[0].outer}
                      onChange={(e) =>
                        setEyeRadius([
                          { ...eyeRadius[0], outer: Number(e.target.value) },
                          { ...eyeRadius[1], outer: Number(e.target.value) },
                          { ...eyeRadius[2], outer: Number(e.target.value) },
                        ])
                      }
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Eye Inner Radius"
                      variant="outlined"
                      type="number"
                      value={eyeRadius[0].inner}
                      onChange={(e) =>
                        setEyeRadius([
                          { ...eyeRadius[0], inner: Number(e.target.value) },
                          { ...eyeRadius[1], inner: Number(e.target.value) },
                          { ...eyeRadius[2], inner: Number(e.target.value) },
                        ])
                      }
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="QR Style"
                      variant="outlined"
                      select
                      value={qrStyle}
                      onChange={(e) => setQrStyle(e.target.value)}
                      fullWidth>
                      <MenuItem value="squares">Squares</MenuItem>
                      <MenuItem value="dots">Dots</MenuItem>
                      <MenuItem value="rounded">Rounded</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={clearLogoBg}
                          onChange={(e) => setClearLogoBg(e.target.checked)}
                        />
                      }
                      label="Clear Logo Background"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Button variant="outlined" component="label" fullWidth>
                          Upload Logo
                          <input type="file" hidden onChange={handleLogoUpload} />
                        </Button>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Button
                          variant="outlined"
                          onClick={() => setLogoUrl("")}
                          fullWidth
                        >
                          Remove Logo
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Logo Width"
                      variant="outlined"
                      type="number"
                      value={logoWidth}
                      onChange={(e) => setLogoWidth(Number(e.target.value))}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Logo Height"
                      variant="outlined"
                      type="number"
                      value={logoHeight}
                      onChange={(e) => setLogoHeight(Number(e.target.value))}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          {link !== "" && (
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}>
                <CardHeader title="Generated QR Code" />
                <CardContent sx={{ flexGrow: 1 }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 2,
                    }}>
                    <Box id="qr-code" ref={qrCodeRef}>
                      <QRCode
                        value={link}
                        size={qrSize}
                        ecLevel="M"
                        eyeRadius={eyeRadius}
                        eyeColor={eyeColor}
                        qrStyle={qrStyle}
                        fgColor={fgColor}
                        bgColor={bgColor}
                        quietZone={10}
                        logoImage={logoUrl}
                        logoWidth={logoWidth}
                        logoHeight={logoHeight}
                        removeQrCodeBehindLogo={clearLogoBg}
                      />
                    </Box>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={handlePrint}>
                      Update Qr Code
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          )}
        </Grid>
      </Box>
      <Footer />
    </Box>
  );
};

export default CustomQRCode;
